import React from 'react';
import { TemplateFormItemsProps } from '../factory';

const TemplateFormItems: React.FC<TemplateFormItemsProps> = () => {
  return null;
};

export default TemplateFormItems;
